<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <loading
      :active.sync="loading"
      :is-full-page="true"
  ></loading>

  <div class="text-right" v-if="contactosPaciente.length === 0" style="margin-top: -28px; cursor: pointer">
    <em class="btn_plus" @click="formularioAgregar = true"/>
  </div>

  <b-card class="cardContacto" v-if="!formularioAgregar" style="overflow-y: scroll">
    <b-row>
      <b-col>
        <b-table-simple>
          <b-thead>
            <b-tr >
              <b-th>Medio de contacto</b-th>
              <b-th>Información</b-th>
              <b-th>Selección</b-th>
            </b-tr>
          </b-thead>
          <tr
              v-for="(item, index) in contactosPaciente"
              :key="index"
          >
            <td >{{ item.medioContacto }}</td>
            <td> {{item.contacto }} </td>
            <td class="text-center">
              <b-form-radio
                  v-model="idMedioContactoPaciente"
                  name="some-radios"
                  :value="item.idMedioContactoPaciente"
              ></b-form-radio>
            </td>
          </tr>
        </b-table-simple>
        <div v-if="contactosPaciente.length === 0" class="text-center" style="font-size: 12px">
          <b-alert variant="ligth" show>Sin medios de contacto registrados</b-alert>
        </div>
      </b-col>
    </b-row>

  </b-card>

  <b-card class="cardContacto" v-else>
    <b-col>
      <b-form v-on:submit.prevent="guardarContacto" >
        <div>
          <label>Medio de contacto: </label>
          <b-form-select
              v-model="contactoGuardar.idMedioContacto"
              size="sm"
              :options="listaContacto"
              value-field="idMedioContacto"
              text-field="descripcion"
              :state="contactoGuardar.idMedioContacto != null"
          ></b-form-select>
          <b-form-invalid-feedback :state="contactoGuardar.idMedioContacto != null">
            Se debe seleccionar una opción
          </b-form-invalid-feedback>
        </div>
        <div>
          <div
              v-if="contactoGuardar.idMedioContacto === 1 || contactoGuardar.idMedioContacto === 2 || contactoGuardar.idMedioContacto === 4">
            <label>Número: *</label>
            <VuePhoneNumberInput
                v-model="contactoGuardar.contacto"
                maxlength="13"
                default-country-code="MX"

                placeholder="Ingresa número a 10 dígitos: *"
                :state="contactoGuardar.contacto != null"
            />
            <b-form-invalid-feedback :state="contactoGuardar.contacto != null">
              Debe ingresar un número
            </b-form-invalid-feedback>
          </div>
          <div v-if="contactoGuardar.idMedioContacto === 3">
            <label> Correo: *</label>
            <b-form-input
                type="email"
                v-model="contactoGuardar.contacto"
                placeholder="Correo: "
                max="5"
                :state="contactoGuardar.contacto != null"
            ></b-form-input>
            <b-form-invalid-feedback :state="contactoGuardar.contacto != null">
              Debe ingresar un correo
            </b-form-invalid-feedback>
          </div>
        </div>


      </b-form>
    </b-col>
  </b-card>

  <div style="display: flex; flex-direction: row; justify-content: center;" v-if="formularioAgregar">
    <div style="padding:1%">
      <b-button variant="outline-primary" class="mt-4" type="submit" size="sm" @click="guardarContacto" pill>
        Guardar Contacto
      </b-button>
    </div>

  </div>
  <div class="text-center" v-else>
    <br/>
    <b-button variant="outline-ligth" style="background-color: #1B81AF;" pill @click="guardarPti()" :disabled="contactosPaciente.length === 0 || idMedioContactoPaciente == null ">
      <span style="color: #FFFFFF" >Finalizar</span>
    </b-button>
  </div>

</div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import {PacienteService} from "@/apiServices/paciente/PacienteService";
export default {
  components: {
    VuePhoneNumberInput,
  },
  name: "ContactoPacienteV5",
  props: {
    idPaciente: Number,
    loading: Boolean,
  },
  data:() => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listaContacto: [],
    contactoGuardar: {
      idMedioContacto: null,
      contacto: null,
    },
    pacienteService: new PacienteService(),
    formularioAgregar: false,
    contactosPaciente: [],
    idMedioContactoPaciente: null,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.traerListaContacto();
    this.obtenerContactoPaciente()
  },
  watch: {
    idMedioContactoPaciente: function () {
      this.$emit("_setearValor", this.idMedioContactoPaciente);
      this.$forceUpdate();
    },
  },
  methods: {
    finalizarPresentacion(){

    },
    guardarPti(){
      this.$emit("guardarOpcionAceptada")
    },
    traerListaContacto() {
        const urlContacto = this.$api + "catalogos/listaMediosContacto";
        this.$http.get(urlContacto)
            .then((response) => {
              if (response.data.data) {
                response.data.data.unshift({
                  idMedioContacto: null,
                  descripcion: "Medio contacto:",
                });
                this.listaContacto = response.data.data;
              }
            })
            .catch((err) => {
              this.showErroMsg(err);
            });

    },
    guardarContacto() {
      if (this.contactoGuardar.idMedioContacto !== 3) {
        if (this.contactoGuardar.contacto.replace(/\s+/g, "").length !== 10) {
          this.$swal({
            icon: "warning",
            text: "Los números de teléfono deben ser de 10 dígitos",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          return false;
        }
      }
      var datos = {
        idPaciente: this.idPaciente,
        idMedioContacto: this.contactoGuardar.idMedioContacto,
        contacto: this.contactoGuardar.contacto,
        idMedioContactoPaciente: null,
      };
      this.pacienteService.guardarMedioContacto(datos).then(() => {
        this.formularioAgregar = false;
        this.contactoGuardar = {
          idMedioContacto: null,
          contacto: null,
        };
        this.obtenerContactoPaciente();
      });
    },
    obtenerContactoPaciente() {
      this.paginaActual = 1;
      const parametros = {idPaciente: this.idPaciente}
      this.pacienteService.obtenerMediosContactoPaciente(parametros)
          .then((r) => {
            this.contactosPaciente = r;
          })
          .catch((err) => {
            console.error(err);
          });
    },
  }
}
</script>

<style scoped>
.cardContacto {
  border:1px solid  #90D3DD;
  border-radius: 1rem;
  width: 102%;
  height: 190px;
}
.table th, .table td {
  padding: 0.75rem;
  padding: 0.50rem;
  vertical-align: middle;
  border-top: 0px solid #dee2e6;
  font-size: 12px;
}
</style>